module.exports = "/_next/static/images/account-frozen-8ce4004e0ae869f0a4d320e1eea43c58.svg";